module.exports = __webpack_public_path__ + "img/ico-filter.d8ee98a6.svg";